import styled from '@emotion/styled';

import { Text } from '@myrealtrip/web-ui';

const TravelerAgeDescriptionTable = () => {
  return (
    <TravelerAgeDescriptionContainer>
      <Text typography="paragraphNormal13">
        ⚠️ 나이는 탑승일 기준으로 선택해주세요. 탑승일 기준 만 나이가 헷갈린다면, 아래의{' '}
        {`<만 나이 확인해보기>`} 를 활용해보세요
      </Text>
      <ExampleTable>
        <thead>
          <tr>
            <th>현재 나이</th>
            <th>생일</th>
            <th>탑승일</th>
            <th>입력할 나이</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>만 25세</td>
            <td>2월 1일</td>
            <td>1월 31일</td>
            <td>
              <strong>만 25세</strong>
            </td>
          </tr>
          <tr>
            <td>만 25세</td>
            <td>2월 1일</td>
            <td>2월 1일</td>
            <td>
              <strong>만 26세</strong>
            </td>
          </tr>
          <tr>
            <td>만 25세</td>
            <td>2월 1일</td>
            <td>2월 2일</td>
            <td>
              <strong>만 26세</strong>
            </td>
          </tr>
        </tbody>
      </ExampleTable>
      <Text typography="paragraphNormal13">
        입력한 나이를 기준으로 승객 유형(성인, 청소년, 시니어)이 자동으로 설정되며, 철도사마다 승객
        유형에 따른 나이 기준이 다를 수 있어요.
      </Text>
    </TravelerAgeDescriptionContainer>
  );
};

const TravelerAgeDescriptionContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.yellow.s50};
  border-radius: 12px;
  margin: 0 20px;
  padding: 10px;
  color: #856404;
  word-break: keep-all;
`;

const ExampleTable = styled.table`
  width: 100%;
  margin: 8px 0;
  border-collapse: collapse;
  font-size: 12px;

  th,
  td {
    padding: 6px 4px;
    text-align: center;
    color: #856404;
    // border: 1px solid ${({ theme }) => theme.colors.yellow.s700}40;
    border: 1px solid #856404;
  }

  th {
    background: ${({ theme }) => theme.colors.yellow.s700}20;
    // color: #856404;

    font-weight: 600;
  }

  td strong {
    font-weight: 700;
  }
`;

export default TravelerAgeDescriptionTable;
